import type { IEquipmentItem } from '@shared/types';

import { TRAINER_MODELS } from './trainer-models';

export const TRAINERS_ITEMS: IEquipmentItem[] = [
  {
    ...TRAINER_MODELS.benchPress,
    id: 'tr-01',
    categorySlug: 'trainers',
    number: '01',
    photos: ['/equipment/trainers/01. Жим лежа.webp'],
  },
  {
    ...TRAINER_MODELS.shoulderPress,
    id: 'tr-02',
    categorySlug: 'trainers',
    number: '02',
    photos: ['/equipment/trainers/02. Жим вверх.webp'],
  },
  {
    ...TRAINER_MODELS.seatedRow,
    id: 'tr-03',
    categorySlug: 'trainers',
    number: '03',
    photos: ['/equipment/trainers/03. Рычажная тяга.webp'],
  },
  {
    id: 'tr-04',
    categorySlug: 'trainers',
    number: '04',
    title: 'Становая тяга',
    description:
      'Рычажный тренажёр с двумя боковыми рукоятями для тяги из положения стоя. Рукояти поднимаются при разгибании ног и корпуса; траекторию движения задают рычаги тренажёра.',
    photos: ['/equipment/trainers/04. Становая тяга.webp'],
    videoUrl: 'https://rutube.ru/play/embed/aa44cfd7c78b9802d360086ba80171af',
    videoTitle: 'Становая тяга с боковыми рукоятями',
    specs: [
      { label: 'Ход рукоятей', value: '500 мм' },
      { label: 'Диаметр трубы', value: '60 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '200 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Становая тяга с боковыми рукоятями',
        inVideo: true,
        start:
          'Встаньте между рукоятями, поставьте стопы примерно на ширине таза. Отведите таз назад, согните колени и возьмитесь за рукояти, сохраняя спину ровной.',
        steps: [
          'Опираясь на всю стопу, плавно выпрямите ноги и корпус, поднимая рукояти.',
          'В верхнем положении встаньте ровно, без отклонения назад.',
          'Отведите таз назад, согните колени и медленно опустите рукояти.',
        ],
        tips: [
          'Держите рукояти близко к бокам, а плечи — на одном уровне.',
          'Не округляйте поясницу и не начинайте движение рывком.',
        ],
      },
    ],
    safetyNote:
      'Первое занятие и выбор нагрузки проведите с инструктором. Не бросайте рычаги и не допускайте людей в зону их движения.',
  },
  {
    ...TRAINER_MODELS.gravitron,
    id: 'tr-05',
    categorySlug: 'trainers',
    number: '05',
    photos: ['/equipment/trainers/05. Гравитрон.webp'],
  },
  {
    ...TRAINER_MODELS.hyperextension,
    id: 'tr-06',
    categorySlug: 'trainers',
    number: '06',
    photos: ['/equipment/trainers/06. Гиперэкстензия.webp'],
  },
  {
    id: 'tr-07',
    categorySlug: 'trainers',
    number: '07',
    title: 'Мультиштанга',
    description:
      'Рычажный тренажёр с общей рабочей перекладиной и рукоятями. Используется для приседаний с удержанием перекладины на уровне плеч.',
    photos: ['/equipment/trainers/07. Мультиштанга.webp'],
    videoUrl: 'https://rutube.ru/play/embed/7c2f553cd2e3984042fcb1b15ae6ee0e',
    videoTitle: 'Приседания с рычажной штангой',
    specs: [
      { label: 'Высота стоек', value: '1 800 мм' },
      { label: 'Ширина', value: '1 200 мм' },
      { label: 'Диаметр трубы', value: '60 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '300 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Приседания с рычажной штангой',
        inVideo: true,
        start:
          'Встаньте у рабочей перекладины, возьмитесь за неё двумя руками и поднимите к уровню плеч. Поставьте стопы устойчиво, немного шире таза.',
        steps: [
          'Согните ноги и отведите таз назад, плавно опускаясь в присед до удобной глубины.',
          'Разогните ноги и вернитесь в положение стоя, сохраняя перекладину на уровне плеч.',
          'После подхода плавно опустите рычаги в исходное положение.',
        ],
        tips: [
          'Направляйте колени в сторону носков и сохраняйте пятки на покрытии.',
          'Держите спину ровной, без рывков и отклонения назад.',
        ],
      },
    ],
    safetyNote:
      'До первого занятия попросите инструктора показать положение перекладины и способ входа в упражнение. Не меняйте хват и нагрузку во время движения.',
  },
  {
    ...TRAINER_MODELS.exerciseBike,
    id: 'tr-08',
    categorySlug: 'trainers',
    number: '08',
    photos: ['/equipment/trainers/08. Велотренажер.webp'],
  },
  {
    ...TRAINER_MODELS.cycleElliptical,
    id: 'tr-09',
    categorySlug: 'trainers',
    number: '09',
    photos: ['/equipment/trainers/09. Велоорбитрек.webp'],
  },
  {
    ...TRAINER_MODELS.ellipticalTrainer,
    id: 'tr-10',
    categorySlug: 'trainers',
    number: '10',
    photos: ['/equipment/trainers/10. Эллиптический.webp'],
  },
];
